module.exports = "<section class=content> <div id=admin_requests_table></div> </section>";